export default __webpack_public_path__ + "static/media/sprinterinside.35db343f.jpg";